<template>
  <ElSwitch class="ts-switch" v-bind="$attrs" v-on="$listeners"></ElSwitch>
</template>

<style lang="scss" scoped>
.ts-switch::v-deep {
  .el-switch__core {
    box-shadow: inset 8px 8px 16px 0 #a6abbd, inset -8px -8px 16px 0 #fafbff;
    background-blend-mode: soft-light, normal;
    background-image: linear-gradient(299deg, #000000, #ffffff -2%), linear-gradient(to bottom, #ebecf0, #ebecf0);

    &::after {
      box-shadow: 6px 6px 16px 0 rgba(166, 171, 189, 0.4), -6px -6px 16px 0 rgba(250, 251, 255, 0.4);
      background-blend-mode: soft-light, normal;
      background-image: linear-gradient(308deg, #000000, #ffffff -3%), linear-gradient(to bottom, #ebecf0, #ebecf0);
    }
  }

  &.is-checked {
    .el-switch__core {
      box-shadow: inset 0 -4px 8px 0 rgba(235, 255, 247, 0.88), inset 0 4px 8px 0 rgba(24, 122, 92, 0.4);
      border: solid 1px rgba(235, 236, 240, 0.24);
      background-color: #99ffd1;
      background-image: none;
    }
  }
}
</style>

<script>
import { Switch } from 'element-ui';

export default {
  name: 'TsSwitch',
  components: {
    ElSwitch: Switch
  }
};
</script>
